// Windows browsers change a focused, closed <select> one option per wheel
// event (or held arrow key), even when nobody means to scroll it: trackpad
// momentum right after a pick is enough. Owner 2026-10-08, Chrome on Windows:
// one "Available on" pick sent web, mac, windows, ios, android and visionos in
// 165 ms and always landed on visionOS. Installed once for the whole admin
// (index.js), so every dropdown is covered:
//
// - a pick made with the pointer (mouse, trackpad, touch) lets go of focus,
//   so what follows scrolls the page instead of stepping the value;
// - a wheel over a focused select lets go of focus first, for the same
//   reason (the browser only steps a select that has focus).
//
// Keyboard use is untouched: a select reached and changed with the keyboard
// keeps its focus, as does one where a key was pressed after the pointer.
// Multi-selects are left alone: there the wheel scrolls the list.
const singleSelect = target => {
  const select = target && typeof target.closest === 'function' ? target.closest('select') : null
  return select && !select.multiple ? select : null
}

export const installSelectGuard = doc => {
  let pointerSelect = null

  const onPointerDown = e => {
    pointerSelect = singleSelect(e.target)
  }
  const onKeyDown = e => {
    if (pointerSelect && singleSelect(e.target) === pointerSelect) pointerSelect = null
  }
  const onChange = e => {
    const select = singleSelect(e.target)
    if (select && select === pointerSelect) {
      pointerSelect = null
      select.blur()
    }
  }
  const onWheel = e => {
    const select = singleSelect(e.target)
    if (select && doc.activeElement === select) select.blur()
  }

  const listeners = [
    ['pointerdown', onPointerDown, true],
    ['mousedown', onPointerDown, true],
    ['keydown', onKeyDown, true],
    ['change', onChange, true],
    ['wheel', onWheel, { capture: true, passive: true }]
  ]
  listeners.forEach(([type, fn, options]) => doc.addEventListener(type, fn, options))
  return () => listeners.forEach(([type, fn, options]) => doc.removeEventListener(type, fn, options))
}
